import { Flex, Tag, Typography, Skeleton } from 'antd';

import s from './styles.module.scss';

import type { FC } from 'react';

const { Text } = Typography;

interface InfoBlockProps {
  label: string;
  value: string;
  isProgramDisplay?: boolean;
  isLoading?: boolean;
}

const InfoBlock: FC<InfoBlockProps> = ({
  label,
  value,
  isProgramDisplay,
  isLoading,
}) => {
  const programTypes = isProgramDisplay ? value.split('/') : undefined;

  const renderValue = () => {
    if (isLoading) {
      if (isProgramDisplay) {
        return (
          <Flex gap={6} align="center">
            <Skeleton.Node active className={s['skeleton-tag']} />
            <Skeleton.Node active className={s['skeleton-tag']} />
          </Flex>
        );
      }
      return <Skeleton.Node active className={s['skeleton-value']} />;
    }

    if (isProgramDisplay) {
      return (
        <Flex gap={6} align="center">
          {programTypes?.map((type) => (
            <Tag
              color={type === 'RPM' ? 'orange' : 'blue'}
              key={type}
              className={s['info-block-value-type-tag']}
            >
              {type}
            </Tag>
          ))}
        </Flex>
      );
    }

    return <Text className={s['info-block-value']}>{value}</Text>;
  };

  return (
    <Flex className={s['info-block']} align="center" justify="space-between">
      <Text className={s['info-block-label']}>{label}</Text>
      {renderValue()}
    </Flex>
  );
};
export default InfoBlock;
